<template>
    <div>
        <!-- Bandejas diferentes de Tesorero-->
        <div v-if="user.nivel_acceso !== 'tesorero'">
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Bandeja de autorizaciones histórica</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-toolbar flat color="white">
                <v-divider ></v-divider>
            </v-toolbar>
            <!-- Bandejas de supervisor y financiero -->
            <v-tabs fixed-tabs> 
                <!-- Tabs de la pagina -->
                <v-tab>Individuales</v-tab>
                <v-tab>Grupos</v-tab>
                <!-- Contenido de las Tabs -->
                <!-- Tab de Solicitudes -->
                <v-tab-item>
                    <v-data-table :headers="headers" :items="solicitudes" :search="searchSolicitud" class="elevation-1" v-model="selected_solicitudes" show-select item-key="id_solicitud">
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="searchSolicitud" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus" v-model="alerta_estatus">Estatus cambiado exitosamente</v-alert>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_edicion" v-model="alerta_edicion">Solicitud editada exitosamente</v-alert>
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-right" style="margin-top:35px">
                                <div v-if="mostrar_cargar"><v-progress-circular indeterminate color="primary" ></v-progress-circular>Descargando archivo de excel.</div>
                                <v-btn class="ma-2" color="primary" @click="generate_xlsx">Generar Poliza</v-btn>
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-truncate">
                                <v-icon small @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                            <div v-if="user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'financiero' || user.nivel_acceso === 'director general'"  class="text-truncate">
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <!-- Tab de Grupos -->
                <v-tab-item>
                    <v-data-table :headers="headers_grupos" :items="grupos" :search="search_grupos" class="elevation-1" show-select item-key="id_grupo" v-model="selected_grupos">
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="search_grupos" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus_grupos" v-model="alerta_estatus_grupos">Estatus cambiado exitosamente</v-alert>
                           
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small @click="show_dialog_details_grupos(item)">mdi-eye</v-icon>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs>
        </div>
        <!-- Bandejas de Tesorero -->
        <div v-if="user.nivel_acceso === 'tesorero'">
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Autorización de Comprobantes</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-toolbar flat color="white">
                <v-divider ></v-divider>
            </v-toolbar>
            <v-tabs fixed-tabs>
                <!-- Tabs de la pagina -->
                <v-tab>Por Pagar</v-tab>
                <v-tab>Pagadas</v-tab>
                <v-tab-item>
                    <v-data-table :headers="headers_tesorero" :items="solicitudes" :search="search_solicitudes_por_pagar" class="elevation-1" v-model="selected_solicitudes" :show-select="user.nivel_acceso === 'tesorero'" item-key="id_solicitud">
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="search_solicitudes_por_pagar" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus">Estatus cambiado exitosamente</v-alert>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_edicion">Solicitud editada exitosamente</v-alert>
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-right" style="margin-top:35px">
                                <div v-if="mostrar_cargar"><v-progress-circular indeterminate color="primary" ></v-progress-circular>Descargando archivo de excel.</div>
                                <v-btn class="ma-2" color="primary" @click="generate_xlsx">Generar Poliza</v-btn>
                            </div>
                            <div style="margin-top:35px">
                                <v-btn class="ma-2" color="primary" @click="refresh">Actualizar</v-btn>
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-truncate">
                                <v-icon small @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                            <div v-if="user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'financiero' || user.nivel_acceso === 'director financiero' || user.nivel_acceso === 'director general'"  class="text-truncate">
                                <v-icon 
                                    :disabled="((user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'director financiero' || user.nivel_acceso === 'director general') && (item.id_estatus!=='1')) || (user.nivel_acceso === 'financiero' && (item.id_estatus_financiero!=='1' || item.id_estatus_financiero===null))" 
                                    small class="mr-1" @click="show_update_dialog(item)">
                                        mdi-credit-card-check
                                </v-icon>
                                <v-icon 
                                    :disabled="(user.nivel_acceso === 'supervisor' && (item.id_estatus!=='1')) || (user.nivel_acceso === 'financiero' && (item.id_estatus_financiero!=='1' || item.id_estatus_financiero===null))"
                                    small class="mr-1" @click="show_edit_dialog(item)">
                                        mdi-pencil
                                </v-icon>
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <v-tab-item>
                    <v-data-table :headers="headers_tesorero" :items="solicitudes_pagadas" :search="search_solicitudes_pagadas" class="elevation-1" >
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="search_solicitudes_pagadas" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <div style="margin-top:35px">
                                <v-btn class="ma-2" color="primary" @click="refresh_paid">Actualizar</v-btn>
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-truncate">
                                <v-icon small @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                            <div v-if="user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'financiero'" class="text-truncate">
                                <v-icon 
                                    :disabled="(user.nivel_acceso === 'supervisor' && (item.id_estatus!=='1')) || (user.nivel_acceso === 'financiero' && (item.id_estatus_financiero!=='1' || item.id_estatus_financiero===null))" 
                                    small class="mr-1" @click="show_update_dialog(item)">
                                        mdi-credit-card-check
                                </v-icon>
                                <v-icon 
                                    :disabled="(user.nivel_acceso === 'supervisor' && (item.id_estatus!=='1')) || (user.nivel_acceso === 'financiero' && (item.id_estatus_financiero!=='1' || item.id_estatus_financiero===null))"
                                    small class="mr-1" @click="show_edit_dialog(item)">
                                        mdi-pencil
                                </v-icon>
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>  
            </v-tabs> 
        </div>      
        <!-- POPUPS -->
        <!-- Solicitudes de un grupo -->
        <v-dialog v-model="dialog_solicitudes_grupo">
            <v-card>
                <v-card-title><span class="headline">Solicitudes de Grupo</span></v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="solicitudes_grupo" :search="search_solicitudes_grupo" class="elevation-1" v-model="selected_solicitudes_grupo" show-select item-key="id_solicitud">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title style="color:#1C2546;margin-top:40px"></v-toolbar-title>
                                <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="search_solicitudes_grupo" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus_grupo" v-model="alerta_estatus_grupo">Estatus cambiado exitosamente</v-alert>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_edicion_grupo" v-model="alerta_edicion_grupo">Solicitud editada exitosamente</v-alert>
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-right" style="margin-top:35px">
                                <div v-if="mostrar_cargar"><v-progress-circular indeterminate color="primary" ></v-progress-circular>Descargando archivo de excel.</div>
                                <v-btn class="ma-2" color="primary" @click="generate_xlsx">Generar Poliza</v-btn>
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div v-if="user.nivel_acceso === 'tesorero'" class="text-truncate">
                                <v-icon small @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                            <div v-if="user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'financiero' || user.nivel_acceso === 'director financiero' || user.nivel_acceso === 'director general'"  class="text-truncate">
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>     
        </v-dialog>
        <!-- Autorizar solicitud -->
        <v-dialog v-model="dialog_autorizar_solicitud" max-width="590" >
            <v-card>
                <v-card-title><span class="headline">Autorizar Comprobación</span></v-card-title>
                <v-card-text>
                    <v-form ref="autorizar_solicitud_ref">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-select v-if="(user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'director financiero' || user.nivel_acceso === 'director general')" v-model="estado_autorizar" :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                                <v-select v-if="(user.nivel_acceso === 'financiero' )"  v-model='estado_autorizar' :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea v-if="(user.nivel_acceso === 'supervisor' || user.nivel_acceso === 'director financiero' || user.nivel_acceso === 'director general')" v-model="selected_solicitud.anotaciones" label="Anotaciones" value="selected_solicitud.anotaciones" required></v-textarea>
                                <v-textarea v-if="(user.nivel_acceso === 'financiero' )" v-model="selected_solicitud.anotaciones_financiero" label="Anotaciones" value="selected_solicitud.anotaciones_financiero" required></v-textarea>
                            </v-col>  
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_autorizar_solicitud = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="autorizar_solicitud()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Autorizar muchas solicitudes -->
        <v-dialog v-model="dialog_autorizar_solicitudes" max-width="590" >
            <v-card>
                <v-card-title><span class="headline">Autorizar Comprobaciones</span></v-card-title>
                <v-card-text>
                    <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_error_multiples" v-model="alerta_error_multiples">Se debe seleccionar al menos 1 solicitud pendiente de revisión.</v-alert>
                    <v-form ref="autorizar_solicitudes_ref">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-select v-model="estado_autorizar_multiple" :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea  v-model="anotaciones_multiples" label="Anotaciones" value=""></v-textarea>
                            </v-col>  
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_autorizar_solicitudes = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="autorizar_multiples_solicitudes()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Autorizar muchos grupos -->
        <v-dialog v-model="dialog_autorizar_grupos" max-width="590" >
            <v-card>
                <v-card-title><span class="headline">Autorizar Grupos</span></v-card-title>
                <v-card-text>
                    <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_error_multiples_grupos" v-model="alerta_error_multiples_grupos">Se debe seleccionar al menos 1 grupo con al menos 1 solicitud pendiente de revisión.</v-alert>
                    <v-form ref="autorizar_grupos_ref">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-select v-model="estado_autorizar_multiple" :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea  v-model="anotaciones_multiples" label="Anotaciones" value=""></v-textarea>
                            </v-col>  
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_autorizar_grupos = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="autorizar_multiples_grupos()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Mostrar Solicitud -->
        <v-dialog v-model="dialog_show_solicitud" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Detalles de solicitud</span></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Fecha de solicitud:</strong><br/> {{selected_solicitud.fecha_modified}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Nombre solicitante:</strong><br/> {{selected_solicitud.nombre}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Tipo Gasto:</strong><br/> {{selected_solicitud.nombre_cuenta}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Divisa:</strong><br/> {{selected_solicitud.divisa}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Archivo Presentado:</strong><br/> {{selected_solicitud.tipo_archivo_solicitud}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Tipo de Gasto:</strong><br/> {{selected_solicitud.locacion_solicitud}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Subtotal:</strong><br/> {{selected_solicitud.subtotal_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>IVA:</strong><br/> {{selected_solicitud.iva_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Total:</strong><br/> {{selected_solicitud.importe_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Total (Cambio de divisa):</strong><br/> {{selected_solicitud.importe_cambio}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina">
                            <p><strong>Propina:</strong><br/> {{selected_solicitud.propina}}</p>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina_details">
                            <p><strong>Descripción Propina:</strong><br/> {{selected_solicitud.descripcion_propina}}</p>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina_details">
                            <p><strong>Comensales Propina:</strong><br/> {{selected_solicitud.comensales_propina}}</p>
                        </v-col>
                    </v-row>
                    <v-row v-if="requiere_descripcion || selected_solicitud.comentarios!=='undefined'">
                        <v-col cols="12" sm="12" md="12">
                            <p><strong>Comentarios:</strong><br/> {{selected_solicitud.comentarios}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <p><strong>Descripción:</strong><br/> {{selected_solicitud.descripcion}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <strong>Comprobantes</strong> <br />
                            <v-data-table :headers="fileHeaders" :items="archivos_solicitud" class="elevation-1"> 
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-1" @click="download_file(item)">mdi-download</v-icon>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog_show_solicitud = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card> 
        </v-dialog>
        <!-- Editar Solicitud -->
        <v-dialog v-model="dialog_edit_solicitud" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Editar Solicitud</span></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="selected_solicitud.nombre" label="Deudor" value="selected_solicitud.nombre" disabled></v-text-field>
                        </v-col>  
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea  v-model="selected_solicitud.anotaciones" label="Anotaciones Supervisor" value="selected_solicitud.anotaciones" :disabled="user.nivel_acceso !== 'supervisor'"></v-textarea>
                        </v-col>  
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea v-model="selected_solicitud.anotaciones_financiero" label="Anotaciones Financiero" value="selected_solicitud.anotaciones_financiero" :disabled="user.nivel_acceso !== 'financiero'"></v-textarea>
                        </v-col> 
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="selected_solicitud.fecha_solicitud" label="Fecha Comprobación" append-icon="mdi-calendar" :disabled="selected_solicitud.id_tipo_archivo_solicitud==='1'" v-on="on" :filled="selected_solicitud.id_tipo_archivo_solicitud==='1'" :max='new Date().toISOString().slice(0,10)'></v-text-field>
                                </template>
                                <v-date-picker v-model="selected_solicitud.fecha_solicitud" no-title @input="menu2 = false" :disabled="selected_solicitud.id_tipo_archivo_solicitud==='1'" :max='new Date().toISOString().slice(0,10)'></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="selected_solicitud.total" label="Total" value="selected_solicitud.total" :disabled="selected_solicitud.id_tipo_archivo_solicitud==='1'" :filled="selected_solicitud.id_tipo_archivo_solicitud==='1'"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-select :items="divisas" item-value="id_divisa" item-text="divisa" v-model="selected_solicitud.id_divisa" value="selected_solicitud.id_divisa"  label="Divisa" :disabled="selected_solicitud.id_tipo_archivo_solicitud==='1'" :filled="selected_solicitud.id_tipo_archivo_solicitud==='1'"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select v-model='selected_solicitud.id_cuenta' :items="cuentas" value='selected_solicitud.id_cuenta' item-value="id_cuenta" item-text="nombre_cuenta" label="Tipo Gasto" @change="mostrar_descripciones_propina"></v-select>
                        </v-col>
                    </v-row>
                    <v-row >
                        <v-col cols="12" sm="6" md="6" v-if="selected_solicitud.id_forma_solicitud==='2'">
                            <v-text-field v-model="selected_solicitud.monto_cambio" label="Tipo Cambio" value="selected_solicitud.monto_cambio" :filled="selected_solicitud.id_tipo_archivo_solicitud == 1" :disabled="selected_solicitud.id_tipo_archivo_solicitud == 1"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="requiere_anexos" >
                            <v-text-field v-model="selected_solicitud.propina" label="Propina" value="selected_solicitud.propina"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6" v-if="descripciones_propina">
                            <v-textarea v-model="selected_solicitud.descripcion_propina" label="Descripción de propina" value="selected_solicitud.descripcion_propina" ></v-textarea>
                        </v-col> 
                        <v-col cols="12" sm="6" md="6" v-if="descripciones_propina">
                            <v-textarea v-model="selected_solicitud.comensales_propina" label="Comensales de propina" value="selected_solicitud.comensales_propina" ></v-textarea>
                        </v-col> 
                    </v-row>
                    <v-row v-if="requiere_descripcion">
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea v-model="selected_solicitud.comentarios" label="Comentarios" value="selected_solicitud.descripcion"></v-textarea>
                        </v-col>  
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea v-model="selected_solicitud.descripcion" label="Descripción" value="selected_solicitud.descripcion" :disabled="selected_solicitud.id_tipo_archivo_solicitud==='1'" :filled="selected_solicitud.id_tipo_archivo_solicitud==='1'"></v-textarea>
                        </v-col>  
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h6 style="margin-bottom: 20px">Comprobantes</h6>
                            <v-data-table :headers="fileHeaders" :items="archivos_solicitud" class="elevation-1"> 
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-1" @click="download_file(item)">mdi-download</v-icon>
                                    <v-icon small class="mr-1" @click="delete_file(item)" v-if='(selected_solicitud.id_forma_solicitud ==="1" && item.id_tipo_archivo!=="1")'>mdi-delete</v-icon>
                                    <v-icon small class="mr-1" @click="delete_file(item)" v-if='(selected_solicitud.id_forma_solicitud ==="2")'>mdi-delete</v-icon>
                                </template>
                            </v-data-table>
                        </v-col>  
                    </v-row>
                    <v-row v-if="selected_solicitud.id_forma_solicitud==='2'">
                        <v-col cols="12" sm="12" md="12">
                            <v-file-input v-model="selected_solicitud.comprobantes" ref="fileInput" placeholder="Agregar comprobantes" label="Comprobantes" multiple prepend-icon="mdi-paperclip" >
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                    <v-row v-if="requiere_anexos">
                        <v-col cols="12" sm="12" md="12">
                            <v-file-input v-model="selected_solicitud.anexos" ref="fileInput" placeholder="Agregar anexos" label="Anexos" multiple prepend-icon="mdi-paperclip" >
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_edit_solicitud = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="edit_solicitud()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Historial de la Solicitud -->
        <v-dialog v-model="dialog_log_solicitud" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Historial de solicitud</span></v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers_log" :items="log_solicitud" class="elevation-1"></v-data-table>
                </v-card-text>
                <v-card-text>
                    <v-data-table :headers="[{'text': 'Supervisor','value':'anotaciones'},{'text': 'Financiero','value':'anotaciones_financiero'}]" :items="log_comment" class="elevation-1">
                    </v-data-table>
                </v-card-text>
            </v-card> 
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import router from '../../router/index.js';

export default {
    data(){
        return {
            fromDateMenu: false,
            fromDateVal: null,
            minDate: "2020-01-05",
            maxDate: "2019-08-30",
            dialog_solicitudes_grupo: false,
            dialog_autorizar_solicitud : false,
            dialog_log_solicitud: false,
            dialog_edit_solicitud : false,
            dialog_show_solicitud : false,
            dialog_autorizar_solicitudes: false,
            dialog_autorizar_grupos: false,
            selected_grupo : null,
            estado_autorizar: null,
            selected_solicitudes_grupo: [],
            estado_autorizar_multiple: null,
            anotaciones_multiples: null,
            alerta_error_multiples: false,
            alerta_estatus_grupo: false,
            alerta_edicion_grupo: false,
            alerta_estatus_grupos: false,
            alerta_error_multiples_grupos: false,
            menu2: false,
            anotaciones: null,
            fecha_formato: null,
            anotaciones_financiero: null,
            archivos_solicitud: null,
            divisas: null,
            show_propina_details: false,
            selected_solicitudes: [],
            solicitudes_pagadas: [],
            alerta_edicion: false,
            alerta_estatus: false,
            descripciones_propina: false,
            requiere_anexos: false,
            show_propina: false,
            requiere_descripcion: false,
            search_solicitudes_por_pagar: '',
            search_solicitudes_pagadas: '',
            selected_grupos:[],
            solicitud_raw: {
                id_solicitud: "",
                id_deudor: "",
                id_divisa: "",
                id_cuenta: "",
                subtotal: "",
                iva: "",
                total: "",
                descripcion: "",
                monto_cambio: "",
                descripcion_propina: "",
                comensales_propina: "",
                propina: "",
                id_estatus: "",
                id_estatus_financiero: "",
                anotaciones: "",
                anotaciones_financiero: ""
            },
            headers:[
                {text: "Fecha de Comprobación", value:"fecha_modified"},
                {text: "Deudor",value: "nombre"},
                {text: "Número Factura",value: "numero_factura"},
                {text: "Cuenta", value: "nombre_cuenta" },
                {text: "Divisa", value: "divisa", sortable: true },
                {text: "Importe", value: "importe_modified" },
                {text: "Es Delegado", value: "es_delegado" },
                {text: "Estatus de Supervisor", value: "estatus", sortable: true },
                {text: "Estatus de Financiero", value: "estatus_financiero", sortable: true },
                {text: "Acciones", value: "actions", sortable: false }
            ],
            headers_tesorero:[
                {text: "Fecha de Comprobación", value:"fecha_modified"},
                {text: "Deudor",value: "nombre"},
                {text: "Pertenece a grupo", value: "nombre_grupo" , align: "left", sortable: true, width: "15%"},
                {text: "Cuenta", value: "nombre_cuenta" },
                {text: "Divisa", value: "divisa", sortable: true },
                {text: "Importe", value: "importe_cambio" },
                {text: "Estatus de Supervisor", value: "estatus", sortable: true },
                {text: "Estatus de Financiero", value: "estatus_financiero", sortable: true },
                {text: "Acciones", value: "actions", sortable: false }
            ],
            headers_grupos:[
                {text: "Nombre del grupo", value:"nombre"},
                {text: "Creador",value: "nombre_creador"},
                {text: "Nombre Grupo", value: "nombre" },
                {text: "Descripción", value: "descripcion" },
                { text: "Monto total", value: "monto_total" },
                {text: "Solicitudes Totales", value: "solicitudes_totales" },
                {text: "Solicitudes en proceso", value: "num_pendientes" },
                {text: "Solicitudes aprobadas totalmente", value: "num_aprobadas", sortable: true },
                {text: "Solicitudes rechazadas (total o parcial)", value: "num_rechazadas" , sortable: true},
                {text: "Acciones", value: "actions", sortable: false }
            ],
            headers_log: [
                {text: "Fecha de acción", value:"fecha"},
                {text: "Nombre autor acción", value:"user"},
                {text: "Acción", value:"descripcion"},
                {text: "Estatus", value:"estatus"}
            ],
            fileHeaders: [
                { text: "Archivo", value: "nombre_archivo"},
                { text: "Tipo de Archivo", value: "tipo_archivo"},
                { text: "Acciones", value: "actions", sortable: false }
            ],
            selected_solicitud : [],
            solicitudes: [],
            solicitudes_pendientes: [],
            solicitudes_grupo: [],
            log_solicitud: [],
            log_comment: [],
            grupos: [],
            estados: [],
            conceptos: [],
            cuentas: [],
            tipos: ['Comprobación', 'Anticipo'],  
            fileItems: [],
            files: null,
            searchSolicitud: '',
            search_grupos: '',
            search_solicitudes_grupo:'',
            mostrar_cargar: false,
            is_waiting: false
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        // End config for axios
        this.get_solicitudes();
        this.get_solicitudes_pagadas();
        this.get_grupos();
        this.get_conceptos();
        this.get_cuentas();
        this.get_divisas();
        this.Dates();
    },
    computed: {
        fromDateDisp() {
            return this.selected_solicitud.fecha_comprobacion;
        },
        user() {
          return this.$store.state.user;
        },
        computedDateFormatted () {
            return this.formatDate(this.selected_solicitud.fecha_comprobacion)
        }
    },
    methods: {
        validate_item(item){
            var nivel_acceso = this.$store.state.user.nivel_acceso;
            if (nivel_acceso === 'supervisor'){
                if (item.es_delegado === 'Sí') {
                    if (item.id_estatus === '1') {
                        return false;
                    }
                    else { 
                        return true;
                    }
                } else {
                    if (item.id_estatus === '1') {
                        return false;
                    } else { 
                        return true;
                    }
                }
            } else if(nivel_acceso === 'director general'){
                if (item.es_delegado === 'Sí') {
                    if (item.id_estatus === '1') {
                        return false;
                    } else if (item.id_estatus_financiero === '1') {
                        return false;
                    }
                    else { 
                        return true;
                    }
                } else {
                    if (item.id_estatus === '1') {
                        return false;
                    } else { 
                        return true;
                    }
                }
            } else if(nivel_acceso === 'financiero'){
                if (item.es_delegado === 'Sí') {
                    if (item.id_estatus === '1') {
                        return false;
                    } else if (item.id_estatus_financiero === '1') {
                        return false;
                    }
                    else { 
                        return true;
                    }
                } else {
                    if (item.es_acargo) {
                        if (item.id_estatus === '1') {
                            return false;
                        } else { 
                            return true;
                        }
                    } else {
                        if (item.id_estatus_financiero === '1') {
                            return false;
                        } else { 
                            return true;
                        }
                    }
                    
                }
            }
        },
        refresh(){
            this.get_solicitudes();
        },
        refresh_grupos(){
            this.get_grupos();
        },
        refresh_paid(){
            this.get_solicitudes_pagadas();
        },
        get_solicitudes() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes_historicas").then( res => { this.solicitudes = res.data;} );
        },
        get_solicitudes_pagadas() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/pagadas").then( res => { this.solicitudes_pagadas = res.data;} );
        },
        Dates() {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();

            today = yyyy + "-" + mm + "-" + dd;    
        },
        get_divisas(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/divisas").then(res => { this.divisas = res.data; });
        },
        get_grupos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/grupos/aprobaciones/supervision_historica").then(res => { this.grupos = res.data; });
        },
        get_conceptos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/conceptos").then(res => { this.conceptos = res.data; });
        },
        get_cuentas() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/cuentas").then(res => { this.cuentas = res.data; });
        },
        get_files_solicitud(id_solicitud){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+id_solicitud).then(res => { this.archivos_solicitud = res.data; });
        },
        get_solicitudes_by_grupo(data){
            this.selected_grupo = data;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/grupo/"+data.id).then( res => { this.solicitudes_grupo = res.data; } );
            this.dialog_solicitudes_grupo = true;
        },
        show_log_solicitud(data){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/historial/"+data.id_solicitud).then(res => {
                this.log_solicitud = res.data.body;
                this.log_comment = res.data.comments;
                this.dialog_log_solicitud = true;
            });
        },
        show_details_dialog(data){
            this.selected_solicitud = Object.assign({}, data);
            this.selected_solicitud.descripcion_propina = (this.selected_solicitud.descripcion_propina==='undefined' ? null: this.selected_solicitud.descripcion_propina);
            this.selected_solicitud.comensales_propina = (this.selected_solicitud.comensales_propina==='undefined' ? null: this.selected_solicitud.comensales_propina);
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.selected_solicitud.id_solicitud).then(res => { 
                this.archivos_solicitud = res.data; 
                this.dialog_show_solicitud = true;
            });
            if (this.selected_solicitud.propina != '0'){
                this.show_propina = true;
            }
            if (this.selected_solicitud.descripcion_propina !== '' && this.selected_solicitud.descripcion_propina !== null) {
                this.show_propina_details = true;
            } else {
                this.show_propina_details = false;
            }
            
        },
        update_solicitud(solicitud){
            axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes", solicitud).then(() => {
                var form_file = new FormData();
                form_file.append('id_solicitud', this.selected_solicitud.id_solicitud);
                if (this.selected_solicitud.comprobantes !== undefined) {
                    this.selected_solicitud.comprobantes.forEach(file => form_file.append('comprobantes', file));
                }
                if (this.selected_solicitud.anexos !== undefined) {
                    this.selected_solicitud.anexos.forEach(file => form_file.append('anexos', file));
                }
                if (this.selected_solicitud.comprobantes !== undefined || this.selected_solicitud.anexos !== undefined) {
                    axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos", form_file).then(() => {
                        this.get_solicitudes();
                        //this.get_grupos();
                    });
                }else{
                    this.get_solicitudes();
                    //this.get_grupos();
                }
                /*
                if ( this.dialog_solicitudes_grupo === true) {
                    this.get_solicitudes_by_grupo(this.selected_grupo);
                }
                */
            });
        },
        show_edit_dialog(data){
            data.id_cuenta = parseInt(data.id_cuenta);
            data.id_divisa = parseInt(data.id_divisa);
            data.fecha_solicitud = data.fecha_solicitud.substr(0, 10);
            this.selected_solicitud = Object.assign({}, data);
            this.selected_solicitud.descripcion_propina = (this.selected_solicitud.descripcion_propina==='undefined' ? null: this.selected_solicitud.descripcion_propina);
            this.selected_solicitud.comensales_propina = (this.selected_solicitud.comensales_propina==='undefined' ? null: this.selected_solicitud.comensales_propina);
            var obj_selected = this.cuentas.filter(data => { return data.id_cuenta === this.selected_solicitud.id_cuenta});
            if(obj_selected[0]['es_anexo_comida']===true){
                this.descripciones_propina=true;
            }else{
                this.descripciones_propina=false;
            }
            if(obj_selected[0]['requiere_anexo']===true){
                this.requiere_anexos=true;
            }else{
                this.requiere_anexos=false;
            }
            if(obj_selected[0]['requiere_descripcion']===true){
                this.requiere_descripcion=true;
            }else{
                this.requiere_descripcion=false;
            }
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.selected_solicitud.id_solicitud).then(res => { 
                this.archivos_solicitud = res.data; 
                this.dialog_edit_solicitud = true;
            });
        },
        show_update_dialog(data){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/estatus").then( res => { this.estados = res.data; } );   
            this.selected_solicitud = data;
            this.estado_autorizar = null;
            this.dialog_autorizar_solicitud = true;
            if (this.$refs.autorizar_solicitud_ref) {
                this.$refs.autorizar_solicitud_ref.reset();
            }
            
        },
        show_dialog_autorizar_solicitudes(){
            this.alerta_error_multiples = false;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/estatus").then( res => { this.estados = res.data; } );
            this.dialog_autorizar_solicitudes = true;
            if (this.$refs.autorizar_solicitudes_ref) {
                this.$refs.autorizar_solicitudes_ref.reset();
            }
        },
        show_dialog_autorizar_grupos(){
            this.alerta_error_multiples_grupos = false;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/estatus").then( res => { this.estados = res.data; } );
            this.dialog_autorizar_grupos = true;
            if (this.$refs.autorizar_grupos_ref) {
                this.$refs.autorizar_grupos_ref.reset();
            }
            
        },
        map_solicitud_array(solicitud){
            this.solicitud_raw['id_solicitud'] = solicitud.id_solicitud;
            this.solicitud_raw['id_divisa'] = solicitud.id_divisa;
            this.solicitud_raw['id_cuenta'] = solicitud.id_cuenta;
            this.solicitud_raw['id_deudor'] = solicitud.id_deudor;
            this.solicitud_raw['subtotal'] = solicitud.subtotal;
            this.solicitud_raw['iva'] = solicitud.iva;
            this.solicitud_raw['total'] = solicitud.total;
            this.solicitud_raw['descripcion'] = solicitud.descripcion;
            this.solicitud_raw['monto_cambio'] = solicitud.monto_cambio;
            this.solicitud_raw['descripcion_propina'] = solicitud.descripcion_propina;
            this.solicitud_raw['comensales_propina'] = solicitud.comensales_propina;
            this.solicitud_raw['propina'] = solicitud.propina;
            this.solicitud_raw['id_estatus'] = solicitud.id_estatus;
            this.solicitud_raw['id_estatus_financiero'] = solicitud.id_estatus_financiero;
            this.solicitud_raw['anotaciones'] = solicitud.anotaciones;  
            this.solicitud_raw['anotaciones_financiero'] = solicitud.anotaciones_financiero;         
        },
        map_solicitud_array_loop(solicitud){
            var solicitud_tmp = {};
            solicitud_tmp['id_solicitud'] = solicitud.id_solicitud;
            solicitud_tmp['id_divisa'] = solicitud.id_divisa;
            solicitud_tmp['id_cuenta'] = solicitud.id_cuenta;
            solicitud_tmp['id_deudor'] = solicitud.id_deudor;
            solicitud_tmp['subtotal'] = solicitud.subtotal;
            solicitud_tmp['iva'] = solicitud.iva;
            solicitud_tmp['total'] = solicitud.total;
            solicitud_tmp['descripcion'] = solicitud.descripcion;
            solicitud_tmp['monto_cambio'] = solicitud.monto_cambio;
            solicitud_tmp['descripcion_propina'] = solicitud.descripcion_propina;
            solicitud_tmp['comensales_propina'] = solicitud.comensales_propina;
            solicitud_tmp['propina'] = solicitud.propina;
            solicitud_tmp['id_estatus'] = solicitud.id_estatus;
            solicitud_tmp['id_estatus_financiero'] = solicitud.id_estatus_financiero;
            solicitud_tmp['anotaciones'] = solicitud.anotaciones;  
            solicitud_tmp['anotaciones_financiero'] = solicitud.anotaciones_financiero;
            return solicitud_tmp;         
        },
        edit_solicitud(){
            this.is_waiting = true;
            this.alerta_edicion = false
            this.map_solicitud_array(this.selected_solicitud);
            var data_f=new FormData()
            for(let x in this.files){
                data_f.append('files',this.files[x]);
            }
            data_f.append('solicitud',JSON.stringify(this.solicitud_raw));
            this.update_solicitud(data_f);
            this.get_solicitudes();
            //this.get_grupos();
            this.files = null;
            this.alerta_edicion = true;
            this.dialog_edit_solicitud = false;
            this.is_waiting = true;
            if(this.dialog_solicitudes_grupo === true){
                this.alerta_edicion_grupo = false;
                this.alerta_edicion_grupo = true;
            }
        },
        autorizar_solicitud(){
            this.is_waiting = true;
            this.alerta_estatus = false;
            if (this.$refs.autorizar_solicitud_ref.validate()){
                this.map_solicitud_array(this.selected_solicitud);
                var nivel_acceso = this.$store.state.user.nivel_acceso;
                if (nivel_acceso === 'financiero') {
                    this.solicitud_raw['es_delegado'] = this.selected_solicitud.es_delegado;
                    this.solicitud_raw['es_acargo'] = this.selected_solicitud.es_acargo;
                }
                var req = {'solicitud': this.solicitud_raw, 'status': this.estado_autorizar};
                try {
                    axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/autorizar", req).then(()=>{ 
                        this.get_solicitudes();
                        this.get_grupos();
                        if(this.dialog_solicitudes_grupo === true){
                            this.refresh_solicitudes_by_grupo();
                        }
                        this.is_waiting = false;
                        this.dialog_autorizar_solicitud = false;
                        this.alerta_estatus = true;
                    }); 
                } catch (error) {
                    this.is_waiting = false;
                }
                
            }
        },
        autorizar_multiples_solicitudes(){
            this.is_waiting = true;
            this.alerta_error_multiples = false;
            var nivel_acceso = this.$store.state.user.nivel_acceso;
            var solicitudes_aprobables = [];
            var solicitudes_seleccionadas = (this.dialog_solicitudes_grupo===true ? this.selected_solicitudes_grupo : this.selected_solicitudes );
            
            if (this.$refs.autorizar_solicitudes_ref.validate()){
                if (solicitudes_seleccionadas.length > 0){
                    for(let y in solicitudes_seleccionadas){
                        var status = (nivel_acceso === 'financiero' ? solicitudes_seleccionadas[y].id_estatus_financiero : solicitudes_seleccionadas[y].id_estatus);
                        var solicitud_tmp;
                        if (nivel_acceso === 'financiero') {
                            if (solicitudes_seleccionadas[y].id_estatus === '1' || solicitudes_seleccionadas[y].id_estatus_financiero === '1') {
                                solicitud_tmp = this.map_solicitud_array_loop(solicitudes_seleccionadas[y]);
                                solicitud_tmp['es_delegado'] = solicitudes_seleccionadas[y].es_delegado;
                                solicitud_tmp['es_acargo'] = solicitudes_seleccionadas[y].es_acargo;
                                solicitudes_aprobables.push(solicitud_tmp);
                            }  
                        } else {
                           if (status === '1') {
                                solicitud_tmp = this.map_solicitud_array_loop(solicitudes_seleccionadas[y]);
                                (nivel_acceso === 'financiero' ? solicitud_tmp['anotaciones'] = this.anotaciones_multiples : solicitud_tmp['anotaciones_financiero'] = this.anotaciones_multiples);
                                solicitudes_aprobables.push(solicitud_tmp);
                            } 
                        }
                    }
                    if (solicitudes_aprobables.length > 0) {
                        
                        var req = {'solicitudes':solicitudes_aprobables , 'status':this.estado_autorizar_multiple};
                        try {
                            axios.post("https://"+process.env.VUE_APP_URL+':3000/gastos/api/v1/solicitudes/autorizar/multiples', req).then(()=>{
                                if(this.dialog_solicitudes_grupo===true){
                                    this.alerta_estatus_grupo = false;
                                    this.selected_solicitudes_grupo = [];
                                    this.refresh_solicitudes_by_grupo();
                                    this.get_grupos();
                                    this.alerta_estatus_grupo = true;
                                } else {
                                    this.alerta_estatus = false;
                                    this.selected_solicitudes = [];
                                    this.get_solicitudes();
                                    this.alerta_estatus = true;
                                }
                                this.is_waiting = false;
                                this.dialog_autorizar_solicitudes = false;
                            });
                        } catch (error) {
                            this.is_waiting = false;
                        }
                    } else {
                        this.is_waiting = false;
                        this.alerta_error_multiples = true;
                    }
                } else {
                    this.is_waiting = false;
                    this.alerta_error_multiples = true;
                }
            } 
    
        },
        autorizar_multiples_grupos(){
            this.is_waiting = true;
            this.alerta_estatus_grupos = false;
            var nivel_acceso = this.$store.state.user.nivel_acceso;
            var grupos_aprobables = [];
            if (this.$refs.autorizar_grupos_ref.validate()) {
                if ( this.selected_grupos.length > 0)  {
                    this.selected_grupos.forEach(grupo => {
                         var solicitudes_pendientes;
                        if (nivel_acceso==='financiero') {
                            if (grupo.es_acargo) {
                                solicitudes_pendientes = grupo.num_pendientes_supervisor;
                            }else{
                                solicitudes_pendientes = grupo.num_pendientes_financiero;
                            }
                            if (grupo.es_delegado) {
                                solicitudes_pendientes = grupo.num_pendientes_supervisor;
                            }
                        } else {
                            solicitudes_pendientes = grupo.num_pendientes_supervisor;
                        }
                        //var solicitudes_pendientes = (nivel_acceso==='financiero' ? grupo.num_pendientes_supervisor : grupo.num_pendientes_supervisor);
                        if (solicitudes_pendientes !== '0') {
                            grupos_aprobables.push(grupo);
                        }
                    });
                    if (grupos_aprobables.length > 0) {
                        var req = {'grupos': this.selected_grupos, 'status': this.estado_autorizar_multiple, 'anotaciones': this.anotaciones_multiples}
                        try {
                            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/grupos/autorizar/todos",req).then(() => {
                                this.get_grupos();
                                this.is_waiting = false;
                                this.alerta_estatus_grupos = true;
                                this.dialog_autorizar_grupos = false;
                                this.selected_grupos = [];
                            });
                        } catch (error) {
                            this.is_waiting = false;
                        }
                        
                    } else {
                        this.is_waiting = false;
                        this.alerta_error_multiples_grupos = true;
                    }
                } else {
                    this.is_waiting = false;
                    this.alerta_error_multiples_grupos = true;
                }
            }
            
            
        },
        download_file(item){
            /*
            axios({
                url: "https://"+process.env.VUE_APP_URL+":3000/download/"+item.id_solicitud+'/'+item.nombre_archivo,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', item.nombre_archivo);
                document.body.appendChild(link);
                link.click();
            });
            */
            window.open("https://" +
          process.env.VUE_APP_URL +
          ":3000/open/" +
          item.id_solicitud +
          "/" +
          item.nombre_archivo)
        },
        delete_file(item){
            axios.post('https://'+process.env.VUE_APP_URL+':3000/delete/file',item)
            .then((response) => {            
                if(response.data.message === 'Archivo eliminado'){
                    axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.selected_solicitud.id_solicitud).then(res => { 
                        this.archivos_solicitud = res.data; 
                    });
                }
            });
        },
        generate_xlsx(){
            this.mostrar_cargar = true;
            axios({
                url: "https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/poliza/",
                method: 'POST',
                responseType: 'blob', 
                data: {'solicitudes': this.selected_solicitudes}// important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.xlsx');
                document.body.appendChild(link);
                link.click();
                this.selected_solicitudes = [];
                this.mostrar_cargar = false;
                this.get_solicitudes();
                this.get_solicitudes_pagadas();
            });
        },
        mostrar_descripciones_propina() {
            var obj_selected = this.cuentas.filter(obj => { return obj.id_cuenta === this.selected_solicitud.id_cuenta});
            if(obj_selected[0]['es_anexo_comida']===true){
                this.descripciones_propina=true;
            }else{
                this.descripciones_propina=false;
            }
            if(obj_selected[0]['requiere_anexo']===true){
                this.requiere_anexos=true;
            }else{
                this.requiere_anexos=false;
            }
            if(obj_selected[0]['requiere_descripcion']===true){
                this.requiere_descripcion=true;
            }else{
                this.requiere_descripcion=false;
            }
        },
        show_dialog_details_grupos(item){
            this.selected_grupo = item;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/grupo/"+item.id_grupo).then(res => {
                this.solicitudes_grupo = res.data;
                this.dialog_solicitudes_grupo = true;
            }); 
        },
        refresh_solicitudes_by_grupo(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/grupo/"+this.selected_grupo.id_grupo).then(res => {
                this.solicitudes_grupo = res.data;
            });
        }
    }  
}
</script>
<style></style>